import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAllMenu } from "../services/menu.service"; // Cambiar importación

export const fetchMenu = createAsyncThunk("menu/fetchMenu", async () => {
    const menu = await getAllMenu();
    return menu;
});

const menuSlice = createSlice({
    name: "menu",
    initialState: {
        menu: [],
        status: "idle",
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMenu.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchMenu.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.menu = action.payload;
            })
            .addCase(fetchMenu.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    },
});

export default menuSlice.reducer;